import React from 'react'

//starting with capital letter will ensure this is treated as a component
const InvGridItemMatInD = ({formObject, viewData, rowKey}) => {

    return (
        <div className="saras-cell">
            <ul className="uiSearchSubList">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li>
                        <span className="sItemCode">{row.rowValues.itemCat.valF}</span>
                        <span className="sItemID">{row.rowValues.itemDetail.valF}</span>
                        <span className="sItemWeight">{row.rowValues.itemQtyIn.valF}</span>
                        <span className="sItemWeight">{row.rowValues.itemQtyOut.valF}</span>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default InvGridItemMatInD
